const demo_app = {
    notification: '提示：先注冊一個賬號，再測試登入體驗。',
};
export default Object.freeze(demo_app);
